import { CMS_URL } from '../../util/config';
export const imgPath = `${CMS_URL}/lib/pet-profile/1.0.0/img/puppy-guide`;
export const navItemsHeight = 60;
export const headerDefaultHeight = 48;
export const headerMaxHeight = 100;
